import { localStorage } from 'dibs-browser-storage';
import get from 'lodash.get';

const RECENT_HISTORY_LIST = 'recent_history_list';
const RECENT_HISTORY_COUNT = 'recent_history_count';
const MAX_RECENT_HISTORY_ITEMS = 6;
const MAX_RECENTLY_VIEWED_ITEMS = 12;
const MAX_DAYS = 30;

const daysBetween = function(timestamp1, timestamp2) {
    const timeDiff = Math.abs(timestamp1 - timestamp2);
    const oneDayInMs = 86400000; // 24h/d * 60m/h * 60s/m * 1000ms/s
    return Math.round(timeDiff / oneDayInMs);
};

export const isValidRecentHistoryItem = function(item, currentItem) {
    const currentTime = new Date().getTime();
    const itemId = item.itemId || item.item_id;
    const isCurrentItem = itemId === get(currentItem, 'itemId') || '';
    return daysBetween(item.timestamp, currentTime) < MAX_DAYS && !isCurrentItem;
};

export const getRecentHistoryList = function(
    currentItem = null,
    maxRecentHistoryItems = MAX_RECENT_HISTORY_ITEMS
) {
    const localRecentHistoryList = localStorage.getItem(RECENT_HISTORY_LIST) || [];
    const index = maxRecentHistoryItems * -1;
    const recentHistoryList = [];
    localRecentHistoryList.forEach(localRecentHistoryItem => {
        if (isValidRecentHistoryItem(localRecentHistoryItem, currentItem)) {
            recentHistoryList.push(localRecentHistoryItem);
        }
    });

    if (recentHistoryList.length > maxRecentHistoryItems) {
        return recentHistoryList.slice(index);
    }
    return recentHistoryList;
};

export const addRecentHistoryItem = function(item) {
    const {
        contemporaryTrackingString,
        firstPhotoWebPath,
        pdpURL,
        title,
        serviceId,
        categoryPath,
        seller,
        isComplete,
        isListingListed,
    } = item;

    /**
     * Add only available items to local storage.
     */
    if (isComplete && isListingListed) {
        const currentDate = new Date();
        const currentItem = {
            contemporaryTrackingString,
            itemTitle: title || document.title,
            itemId: serviceId || '',
            itemImageUrl: firstPhotoWebPath,
            itemPdpUrl: pdpURL,
            dealerPk: get(seller, 'serviceId') || '',
            timestamp: currentDate.getTime(),
            lastVisited: currentDate,
            category: categoryPath,
        };

        const localRecentHistoryList =
            getRecentHistoryList(currentItem, MAX_RECENTLY_VIEWED_ITEMS) || [];

        localRecentHistoryList.push(currentItem);

        localStorage.setItem(RECENT_HISTORY_COUNT, localRecentHistoryList.length);
        localStorage.setItem(RECENT_HISTORY_LIST, JSON.stringify(localRecentHistoryList));
    }
};

export const hasRecentlyViewedItems = ({ itemId }) => {
    const recentItems = getRecentHistoryList({ itemId }, 1);

    return recentItems.length > 0;
};

export const getRecentlyViewedItems = ({ itemId, maxItems }) => {
    const recentItems = getRecentHistoryList({ itemId }, maxItems || MAX_RECENTLY_VIEWED_ITEMS);

    return recentItems.reverse();
};
